import { utcToZonedTime } from "date-fns-tz";
import { format } from "date-fns";

export const formatTime = (date: Date) => format(date, "h:mm aa");

export const formatAsLondonTime = (date: Date) => formatTime(utcToZonedTime(date, "Europe/London"));

export const getAsLondonDate = (date: Date) => utcToZonedTime(date, "Europe/London");
